import PiggyvestIconLogo from '../../assets/images/piggyvest-icon-logo.svg';
import Menu from '../../assets/icons/menu.svg';
// import Close from "../../assets/icons/close.svg";
import useNav from '../../hooks/useNav';
import './MobileNav.scss';
import Sidebar from '../Sidebar/Sidebar';

const MobileNav = () => {
  const { navigation, updateNavigation } = useNav();

  return (
    <div className="navigation">
      <div className="navigation__header">
        <img src={PiggyvestIconLogo} alt="piggyvest logo" />
        <img src={Menu} className="pointer" alt="menu icon" onClick={updateNavigation} />
      </div>
      {navigation && (
        <div className="navigation__overlay" onClick={updateNavigation}>
          <div className="navigation__drawer" onClick={(e) => e.stopPropagation()}>
            <Sidebar onClose={updateNavigation} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileNav;
